export enum UserType {
    GroupOwner = 0,
    User = 1,
    Admin = 2,
}
